import { Box } from '@mui/material';

export const QButtonGroup = ({ children, ...props }: any) => {
  return (
    <Box display="flex" justifyContent="space-between" {...props}>
      {children}
    </Box>
  );
};
